import { styled } from 'stitches.config'
import { Button } from 'components/Button'

export const RecipesRoot = styled('div', {
  backgroundColor: '$tertiary-200',
  width: '100%',
  '@bp2': {},

  '& strong': {
    fontWeight: '$medium'
  }
})

export const Spacer = styled('div', {
  height: '269px',
  background: '$tertiary-200',
  zIndex: 0,
  '@bp2': {
    height: '180px',
  }
})